import { useDispatch, useSelector } from 'react-redux';
import { selectIsBasicPlansComplete, selectIsProductTypeComplete } from '../../../../../helper/proposal/proposal-is-complete-form-helper';
import { Checked } from '../../../../../assets/icon/svg';
import LoadingCategory from '../../../../ui/loading-category';
import ErrorFetch from '../../../../ui/error-fetch-category';
import { useQueries } from '../../../../../hooks/services/queries/use-queries';
import { useMemo } from 'react';
import { setSelectedCoverageTypeBox } from '../../../../../features/gms-proposal-forms/types-proposal-product-basic-plan/types-proposal-product-basic-plan-slice';
import { SubTypeOption } from '../../../../../api/gms/group-category/group-category-api-state';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';

export default function ClientInputCoverageType() {

    const dispatch = useDispatch()
    const { 
        coverageTypeData, 
        isLoadingCoverageTypeData, 
        isErrorCoverageTypeData, 
    } = useQueries()
    const { coverage, } = useProposalTypeData()
    const isProductTypeComplete = useSelector(selectIsProductTypeComplete);
    const isBasicPlansComplete = useSelector(selectIsBasicPlansComplete)
    const isErrorLoading = isErrorCoverageTypeData || isLoadingCoverageTypeData
    const isDisableCheckbox = isProductTypeComplete && isBasicPlansComplete
    
    const mappedOptions: SubTypeOption[] = useMemo(
        () => coverageTypeData?.map(item => ({
            id: item.id,
            name: item.name
        })) || [],[coverageTypeData]
    );

    const handleChangeCoverageType = (option: SubTypeOption) => {
        dispatch(setSelectedCoverageTypeBox(option));
    };

    return (
        <div className='space-y-2'>
            <div className={`grid ${isErrorLoading ? 'grid-cols-1' : 'grid-cols-1 lg:grid-cols-3'} gap-2`}>
                {isLoadingCoverageTypeData ? (
                    <LoadingCategory/>
                ) : isErrorCoverageTypeData ? (
                    <ErrorFetch/>
                ) : (
                    mappedOptions.map((option) => {
                        const isSelected = coverage?.name === option.name;
                        return (
                            <label
                                key={option.id}
                                className={`flex items-center gap-2 rounded border px-3 py-2 transition-all duration-200 
                                    ${!isDisableCheckbox ? 'cursor-not-allowed border-gray-200 bg-gray-100 opacity-50' 
                                        : isSelected ? 'cursor-pointer border-[#186cb2]/30 bg-[#186cb2]/10 shadow-sm' 
                                        : 'cursor-pointer border-gray-200 bg-white hover:border-[#186cb2] hover:bg-gray-50'}
                                `}
                            >
                                <input
                                    type="checkbox"
                                    disabled={!isDisableCheckbox}
                                    checked={isSelected}
                                    onChange={() => handleChangeCoverageType(option)}
                                    className="hidden"
                                />
                                <div className={`flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full border transition-all duration-200 ${isSelected ? 'border-[#186cb2] bg-[#186cb2]' : 'border-gray-400 bg-white'}`}>
                                    {isSelected && (
                                        <Checked />
                                    )}
                                </div>
                                <span
                                    className={`flex-1 whitespace-normal break-words text-xs leading-5
                                        ${isSelected ? 'font-medium text-[#186cb2]' : 'text-gray-700'}
                                    `}
                                >
                                    {option.name}
                                </span>
                            </label>
                        )
                    })
                )}
            </div>
        </div>
    )
}
